import { render, staticRenderFns } from "./WorkflowListActions.vue?vue&type=template&id=f15a683c"
import script from "./WorkflowListActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowListActions.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports